import { createI18n } from 'vue-i18n';
import messages from '@/statics/i18n/messages.json';

const i18n = createI18n({
	legacy: false,
	locale: ['en', 'fr', 'pt', 'es', 'nl'].includes(navigator.language.split('-')[0]) ? navigator.language.split('-')[0] : 'en',
	fallbackLocale: 'en',
	availableLocales: ['en', 'fr', 'pt', 'es', 'nl'],
	messages,
});

export default i18n;
